module.exports = __webpack_public_path__ + "img/shop.0cbbdb69.png";